const getApiOrigin = () => {
  if (typeof window === 'undefined' || !window.location) return 'http://localhost:5001';
  const { protocol, hostname, port, origin } = window.location;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const portStr = String(port || '');
  if (isLocalHost && protocol === 'http:' && portStr !== '5001') return `${protocol}//${hostname}:5001`;
  return origin;
};

const API_ORIGIN = getApiOrigin();
export const BASE_URL = API_ORIGIN;
const API_URL = `${API_ORIGIN}/api`;

export const resolveFileUrl = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  if (raw.startsWith('https//')) return `https://${raw.slice('https//'.length)}`;
  if (raw.startsWith('http//')) return `http://${raw.slice('http//'.length)}`;
  if (raw.startsWith('/')) return `${BASE_URL}${raw}`;
  return `${BASE_URL}/${raw}`;
};

export const api = {
  get: async (table, query = {}) => {
    const params = new URLSearchParams();
    if (query.where) params.append('where', typeof query.where === 'string' ? query.where : JSON.stringify(query.where));
    if (query.orderBy) params.append('orderBy', query.orderBy);
    if (query.limit) params.append('limit', query.limit);
    
    const url = `${API_URL}/${table}${params.toString() ? '?' + params.toString() : ''}`;
    const res = await fetch(url);
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.details || errorData.error || 'API Error');
    }
    const data = await res.json();
    if (data && Array.isArray(data.value)) return data.value;
    return data;
  },
  post: async (table, data, isMultipart = false) => {
    const options = {
      method: 'POST',
      body: isMultipart ? data : JSON.stringify(data),
    };
    if (!isMultipart) {
      options.headers = { 'Content-Type': 'application/json' };
    }
    const res = await fetch(`${API_URL}/${table}`, options);
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.details || errorData.error || 'API Error');
    }
    return res.json();
  },
  put: async (table, id, data) => {
    const res = await fetch(`${API_URL}/${table}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.details || errorData.error || 'API Error');
    }
    return res.json();
  },
  delete: async (table, id) => {
    const res = await fetch(`${API_URL}/${table}/${id}`, {
      method: 'DELETE',
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.details || errorData.error || 'API Error');
    }
    return res.json();
  }
};

export const auth = {
  login: async (email, password) => {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) throw new Error('Auth Error');
    return res.json();
  },
  changePassword: async ({ email, currentPassword, newPassword }) => {
    const res = await fetch(`${API_URL}/auth/change-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, currentPassword, newPassword }),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Auth Error');
    }
    return res.json();
  },
};
